import { Application } from 'hooks/webapi/useApplication';
import { Client } from 'hooks/webapi/useClient';

export const isValidApplication = (
  application: Application | null | undefined,
  client?: Client | null | undefined,
) => {
  const applicationValidation =
    application?.status && application?.status !== 'CLOSED';
  // client validation applied if it's possible but not mandatory
  const clientAppValidation =
    !client ||
    (client?.availableProducts || []).includes(
      application?.productInfo?.number || 'no-defined',
    );
  return applicationValidation && clientAppValidation;
};
